
export default class Embed {

	constructor() {

		//

	}

	/*
	** load
	*/

	load() {

		const embeds = document.querySelectorAll('.embed');

		for (let i = 0; i < embeds.length; ++i) {

			const embed = embeds[i];
			const iframes = embed.querySelectorAll('iframe');

			for (let j = 0; j < iframes.length; ++j) {

				const iframe = iframes[j];

				if (iframe.closest('.fluid-vids')) continue;

				const parent = iframe.parentNode;

				if (
					parent &&
					parent.style &&
					parent.style.position === 'relative' &&
					parent.style.paddingTop
				) {
					continue;
				}

				let width = iframe.getAttribute('width') || 16;
				let height = iframe.getAttribute('height') || 9;

				const ratio = (height / width) * 100;

				iframe.style.position = 'absolute';
				iframe.style.top = '0';
				iframe.style.left = '0';
				iframe.style.width = '100%';
				iframe.style.height = '100%';

				const wrap = document.createElement('div');
				wrap.className = 'fluid-vids';
				wrap.style.width = '100%';
				wrap.style.position = 'relative';
				wrap.style.paddingTop = ratio + '%';

				parent.insertBefore(wrap, iframe);
				wrap.appendChild(iframe);
			}
		}
	}

	/*
	** unload
	*/

	unload() {

		//

	}

}